<template>
  <div
    class="auth-input text-left"
    :class="{
      'has-error': error.length,
      'is-loading': loading,
      'is-disabled': disabled,
      'is-readonly': readonly
    }"
  >
    <label :for="'auth_input_' + _uid">{{ label }}</label>
    <div
      v-if="$slots.instructions"
      class="text-xs italic mb-2 mt-1"
    >
      <slot name="instructions" />
    </div>
    <textarea
      v-if="!locked"
      v-bind="Object.assign({}, $attrs)"
      :id="'auth_input_' + _uid"
      ref="textarea"
      :value="value"
      class="block w-full outline-none"
      :placeholder="placeholder"
      :readonly="loading || locked || readonly"
      :disabled="loading || locked || disabled"
      :required="required"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
    ></textarea>
    <div
      v-else
      class="flex items-center justify-between"
    >
      <span class="text-black">{{ value }}&nbsp;</span>
      <icon
        icon="lock"
        class="icons-grey w-4 h-4"
      />
    </div>
    <slot />
    <p
      v-if="error.length"
      class="text-left text-xs mb-0 mt-2 italic"
      v-html="$sanitizeHtml(error.join(', '))"
    />
    <div v-if="maxlength" class="px-4 bg-grey-100">
      <p
        class="text-right text-xs"
        :class="{
          'text-negative-600': wordCount > maxlength,
          'text-grey-600': wordCount <= maxlength,
        }"
      >
        {{ wordCount }} / {{ maxlength }} words
      </p>
    </div>
  </div>
</template>

<script>
import autosize from "autosize";
export default {
  name: "AuthInput",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    error: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    locked: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    },
    autocomplete: {
      type: [Boolean,String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    wordCount() {
      if (["", "", null, undefined].indexOf(this.value) !== -1)
        return 0;
      return this.value.match(/\S+/g)?.length ?? 0;
    },
  },
  mounted() {
    autosize(this.$refs.textarea);
  },
};
</script>

<style>
.auth-input {
  @apply border-grey-200 border p-3 relative mt-6 mb-4 text-grey-700;
  transition: all 0.2s ease-in-out;
}

.auth-input:focus-within {
  @apply text-secondary-500 border-secondary-500;
}

.auth-input.has-error {
  @apply text-negative-600 border-negative-600;
}

.auth-input.is-disabled {
  @apply text-grey-500 border-grey-300;
}

.auth-input label {
  @apply absolute pin-t pin-l text-xs tracking-wide uppercase font-bold -mt-2 bg-white ml-1 px-2 cursor-pointer;
}

.auth-input input {
  @apply bg-transparent;
}

.auth-input input::placeholder {
  @apply italic;
}
</style>
